import { createClient } from "@supabase/supabase-js";
import { resolveSupabasePublishableKey } from "@omnara/shared-js/config/supabase";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabasePublishableKey = resolveSupabasePublishableKey(import.meta.env);

// Validate env vars in development to catch configuration issues early
if (import.meta.env.DEV) {
  if (!supabaseUrl) {
    console.error(
      "[Supabase] Missing VITE_SUPABASE_URL environment variable. Authentication will not work."
    );
  }
  if (!supabasePublishableKey) {
    console.error(
      "[Supabase] Missing VITE_SUPABASE_PUBLISHABLE_KEY environment variable. Authentication will not work."
    );
  }
}

// In production, throw if env vars are missing to fail fast
if (import.meta.env.PROD && (!supabaseUrl || !supabasePublishableKey)) {
  throw new Error(
    "Missing Supabase configuration. Ensure VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY are set."
  );
}

export const supabase = createClient(supabaseUrl || "", supabasePublishableKey || "", {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
